import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {
    ActionsRow,
    CardItems,
    modal,
    Icon,
    FixedDropDownButton,
    utils,
    Loader,
    commons
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
import {toastr} from "react-redux-toastr";
import TimeLine from "./TimeLine";
import * as objednavkaActions from "../actions/objednavkaActions";
import ObjednavkaEditPolozkaForm from "../forms/ObjednavkaEditPolozkaForm";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
const {sinkEvent} = commons;
import ImportForm, {KOD_UKON_SKLADAT, ZE_SLOZKY} from "../forms/ImportForm";
import ImportPolozkyForm from "../forms/ImportPolozkyForm";
import ObjednavkaAddPolozkyForm from "../forms/ObjednavkaAddPolozkyForm";
import {SubmissionError} from "redux-form";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující fakturační položky objednávky.
 */
class FakturacniPolozkyPanel extends Component<WithTranslation> {

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // VO objednávky
        objednavkaRights: PropTypes.object.isRequired, // VO oprávnění na objednávku
        readOnly: PropTypes.bool, // zda je panel v režimu read-only, tj. nezobrazuje akce pro úpravu, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {objednavka} = this.props;
        this.props.dispatch(objednavkaActions.fetchObjednavkaKodUkonyIfNeeded(objednavka.id));
    };

    handleShowImportPolozekForm = (polozky) => {
        const {objednavka, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ImportPolozkyForm,
            {
                onSubmit: (data) => {
                    this.props.dispatch(modal.ModalActions.showAsyncWaiting(
                        t('please_wait'),
                        <Loader>{t('calculating_item_prices')}</Loader>,
                        ObjednavkaApi.zalozPolozkyByParams(objednavka.id, data.polozky), () => {
                            this.props.dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                            this.props.dispatch(modal.ModalActions.hide());
                        }
                    ));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    polozky: polozky,
                }
            },
            t('billing_items_import'),
            {size: "fullscreen"}
        ));
    };

    handleImportPolozek = () => {
        const {objednavka, kodUkonList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ImportForm,
            {
                onSubmit: (data) => {
                    this.props.dispatch(modal.ModalActions.showAsyncWaiting(
                        t('please_wait'),
                        <Loader>{t('saving_files_for_calculation')}</Loader>,
                        ObjednavkaApi.vypoctiPolozkyObjednavky(objednavka.id, data.soubor === ZE_SLOZKY ? null : data.soubor, data.pocet, data.skladat ? data.skladat : false), (polozky) => {
                            this.props.dispatch(modal.ModalActions.hide());
                            if (polozky.length > 0) {
                                this.handleShowImportPolozekForm(polozky);
                            } else {
                                toastr.warning(t('no_billing_items_loaded'));
                            }
                        }
                    ));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    pocet: objednavka.pocetVyhotoveni,
                    skladat: kodUkonList.rows && kodUkonList.rows.includes(KOD_UKON_SKLADAT),
                    soubor: ZE_SLOZKY,
                },
            },
            t('billing_items_import'),
            {size: "sm"}
        ));
    };

    handleNovaPolozka = () => {
        const {objednavka, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ObjednavkaAddPolozkyForm,
            {
                onSubmit: (data) => {
                    let polozky = data.polozky || [];
                    polozky = polozky.filter(p => p.polozka && p.mnozstvi);
                    if (polozky.length === 0) {
                        throw new SubmissionError({_error: t('validation.at_least_one_item_required')});
                    }
                    const submitVOList = polozky.map(value => {
                        return {
                            polozkaId: value.polozka.id,
                            plu: value.polozka.plu,
                            mnozstvi: value.mnozstvi,
                            specCena: value.specCena,
                            cena: value.cena,
                            sleva: value.sleva,
                        }
                    });
                    return ObjednavkaApi.addObjednavkaPolozky(objednavka.id, submitVOList);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                objednavka: objednavka,
            },
            t('order.add_order_items'),
            {size: "lg"}
        ));
    };

    handleEditPolozka = (polozka) => {
        const {objednavka, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ObjednavkaEditPolozkaForm,
            {
                onSubmit: (data) => {
                    // pozor na to že při editaci se z formuláře vrací ObjednavkaPolozkaVO, ne PolozkaVO
                    const result = {
                        id: data.polozka.id,
                        polozkaId: data.polozka.polozkaId,
                        plu: data.polozka.plu,
                        mnozstvi: data.mnozstvi,
                        cena: data.cena,
                        sleva: data.sleva,
                        specCena: data.specCena,
                    };
                    return ObjednavkaApi.updateObjednavkaPolozka(objednavka.id, result.id, result);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                    objednavkaActions.notifyIfNeeded(result);
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    polozka: polozka,
                    mnozstvi: polozka.mnozstvi,
                    cena: polozka.cena,
                    sleva: polozka.sleva,
                    specCena: polozka.specCena,
                }
            },
            t('order.edit_order_item'),
            {size: "sm"}
        ));
    };

    handleDeletePolozka = (polozka) => {
        const {objednavka, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('order.delete_item'),
                <span>{t('order.delete_item_confirm', {item: <b>{polozka.popisPolozka}</b>})}</span>,
                () => {
                    ObjednavkaApi.deleteObjednavkaPolozka(objednavka.id, polozka.id).then(akceResult => {
                        this.props.dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                        objednavkaActions.notifyIfNeeded(akceResult);
                    });
                },
                null,
                t('delete')
            )
        );
    };

    renderActions = () => {
        const {readOnly, t} = this.props;
        return !readOnly ? <ButtonToolbar>
            <Button onClick={this.handleImportPolozek}>{t('order.items_import')}</Button>
            <Button onClick={this.handleNovaPolozka}>{t('new_f')}</Button>
        </ButtonToolbar> : null;
    };

    renderContextMenu = (polozka) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditPolozka.bind(this, polozka))}>{t('edit')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleDeletePolozka.bind(this, polozka))}>{t('delete')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {objednavka, objednavkaRights, readOnly, t} = this.props;
        return <Card>
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('billing_items_title', {count: objednavka.objednavkaPolozkaList.length})}</h2>
                </ActionsRow>
            </CardHeader>
            {objednavka.objednavkaPolozkaList.length > 0 ?
                <CardItems bordered>
                    {objednavka.objednavkaPolozkaList.map(polozka => <TimeLine className="bordered" color={"finished"} key={polozka.id}>
                        <CardBody>
                            <ActionsRow actions={!readOnly ? this.renderContextMenu(polozka) : null} onClick={!readOnly ? this.handleEditPolozka.bind(this, polozka) : null}>
                                <Row>
                                    <Col xs={4}>{polozka.popisPolozka}</Col>
                                    <Col xs={2}>{polozka.mnozstvi} {polozka.mj || t('pcs').toLowerCase()}</Col>
                                    <Col xs={2} style={{textAlign: "right"}}>{polozka.cena} {t('amount_per_pc')}</Col>
                                    <Col xs={2} style={{textAlign: "right"}}>{polozka.sleva ? `${polozka.sleva} %` : "-"}</Col>
                                    <Col xs={2} style={{textAlign: "right", paddingRight: "2em"}}>{polozka.celkemBezDph} {t('currency_symbol')}</Col>
                                </Row>
                            </ActionsRow>
                        </CardBody>
                    </TimeLine>)}
                    <Row className={"mt-3 mb-3"}>
                        <Col xs={6}/>
                        <Col xs={3}>{t('price_without_vat')}</Col>
                        <Col xs={3} style={{textAlign: "right", paddingRight: "6em"}}>{objednavkaRights.viewObjCena ? objednavka.celkemBezDph : "-"} {t('currency_symbol')}</Col>
                    </Row>
                    <Row className={"mt-3 mb-3"}>
                        <Col xs={6}/>
                        <Col xs={3}><b>{t('order_price_including_vat')}</b></Col>
                        <Col xs={3} style={{textAlign: "right", paddingRight: "6em"}}><b>{objednavkaRights.viewObjCena ? objednavka.celkemSDph : "-"} {t('currency_symbol')}</b></Col>
                    </Row>
                </CardItems>
                : <CardBody><i>{t('no_billing_items')}</i></CardBody>
            }
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        kodUkonList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_KOD_UKON_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(FakturacniPolozkyPanel));
